import type { ContactType } from '../../../contacts/types/contactType'
import type { InvoiceDocumentType } from '../../enums/invoiceDocumentType'
import type { InvoiceStatus } from '../../enums/invoiceStatus'
import type { QuoteStatus } from '../../enums/quoteStatus'
import type { ZervantContactType } from '../../enums/zervantContactType'
import { getDocumentEInvoiceEligibility } from '../../utils/eInvoices/getDocumentEInvoiceEligibility'
import { useInvoiceComplianceMode } from '../useInvoiceComplianceMode'
import { useIsPdpIntegrationActive } from './useIsPdpIntegrationActive'

interface UseDocumentEInvoiceEligibilityOptions {
  contactCountry?: string | null
  contactType?: ZervantContactType | ContactType
  documentStatus?: InvoiceStatus | QuoteStatus
  documentType: InvoiceDocumentType
  isCustomerPublicEntity?: boolean
}

export const useDocumentEInvoiceEligibility = ({
  contactCountry,
  contactType,
  documentStatus,
  documentType,
  isCustomerPublicEntity,
}: UseDocumentEInvoiceEligibilityOptions) => {
  const { isFrenchComplianceMode, isLoading: isLoadingComplianceMode } = useInvoiceComplianceMode()
  const { isPdpIntegrationActive, isLoading: isLoadingPdpIntegration } = useIsPdpIntegrationActive({
    enabled: isFrenchComplianceMode,
  })

  return {
    ...getDocumentEInvoiceEligibility({
      contactCountry,
      contactType,
      documentStatus,
      documentType,
      isCustomerPublicEntity,
      isFrenchComplianceMode,
      isPdpIntegrationActive,
    }),
    isLoading: isLoadingComplianceMode || isLoadingPdpIntegration,
  }
}
